import React, { useMemo, useState } from "react";
import debounce from "lodash/debounce";
import { Select } from "antd"; // Import Ant Design's Select
import { getSearchResult } from "api/search.api";

const { Option } = Select;

export interface UserValue {
  label: string;
  value: string;
}

// Fetch user list from the API
export async function fetchUserList(username: string): Promise<UserValue[]> {
  return getSearchResult(username).then((data: any) => {
    return data.map((label: any) => ({
      label: label,
      value: label,
    }));
  });
}

interface SearchableHiringCompanyProps {
  className?: string;
  placeholder?: string;
  onClick?: () => void;
  onChange?: (value: string) => void; // Handle the selected value
  defaultValue?: UserValue;
  style?: any;
}

const SearchableHiringCompany: React.FC<SearchableHiringCompanyProps> = ({
  className,
  placeholder = "Select...",
  onClick,
  defaultValue,
  style,
  onChange,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState<UserValue[]>([]);
  const [fetching, setFetching] = useState(false);

  // Debounce fetchUserList to reduce the number of API calls
  const debounceFetcher = useMemo(() => {
    const loadOptions = (value: string) => {
      setFetching(true);
      fetchUserList(value).then((newOptions) => {
        setOptions(newOptions);
        setFetching(false);
      });
    };

    return debounce(loadOptions, 800);
  }, []);

  // Handle input change and trigger the debounce fetcher
  const handleInputChange = (value: string) => {
    setInputValue(value);
    debounceFetcher(value);
  };

  const handleSelect = (value: any) => {
    onChange && onChange(value);
  };

  return (
    <Select
      className={className}
      placeholder={placeholder}
      value={defaultValue?.value} // Ant Select expects the value to match an option's value
      showSearch
      filterOption={false} // Disable default filtering, as we're fetching options dynamically
      onSearch={handleInputChange} // Use onSearch for search input in Ant Select
      notFoundContent={fetching ? "Loading..." : null} // Show loading indicator
      onSelect={handleSelect}
      options={options}
      style={{
        width: "100%",
        height: "40px",
        fontSize: "14px",
        ...style
      }}
    >
     
    </Select>
  );
};

export default SearchableHiringCompany;
